import { purposeLabel } from '../../utils/tripLabels.js';
import { csv, mytDateTime, shortRef } from '../finance/financeCsv.js';

/** 361 (#980): one row of `GET /dashboard/trips-export`. */
export interface TripsExportRow {
  id: string;
  rental_id: string;
  is_extension: boolean;
  status: string;
  pickup_at: string;
  return_at: string;
  plate_number: string | null;
  supplier: string | null;
  students: number | null;
  purpose: string | null;
  food_delivery: boolean | null;
  non_halal: boolean | null;
}

const words = (s: string) => {
  const w = s.replace(/_/g, ' ');
  return w.charAt(0).toUpperCase() + w.slice(1);
};
const yesNo = (v: boolean | null) => (v === null ? '' : v ? 'Yes' : 'No');

/** The bookings of a range with the customers' trip answers, for a spreadsheet: words, not codes; Malaysia time. */
export function tripsToCsv(rows: TripsExportRow[]): string {
  return csv([
    [
      'Booking',
      'Rental',
      'Extension',
      'Status',
      'Pickup (MYT)',
      'Return (MYT)',
      'Car',
      'Supplier',
      'Students',
      'Purpose',
      'Food delivery',
      'Non-halal OK',
    ],
    ...rows.map((r) => [
      shortRef(r.id),
      shortRef(r.rental_id),
      r.is_extension ? 'Yes' : 'No',
      words(r.status),
      mytDateTime(r.pickup_at),
      mytDateTime(r.return_at),
      r.plate_number ?? '',
      r.supplier ?? '',
      r.students === null ? '' : String(r.students),
      r.purpose === null ? '' : purposeLabel(r.purpose),
      yesNo(r.food_delivery),
      yesNo(r.non_halal),
    ]),
  ]);
}
